import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";
import {BaseService} from "./base.service";
@Injectable({
  providedIn: 'root'
})
export class JobopeningService  extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }
  create(data): Observable<any> {
    return this.postRequest(AppUrl.JOBOPENING(), data);
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.JOBOPENING(), data);
  }

  detail(unique_id): Observable<any> {
    return this.getRequest(AppUrl.JOBOPENING(unique_id));
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.JOBOPENING(id), data);
  }

  delete(id): Observable<any> {
    return this.deleteRequest(AppUrl.JOBOPENING(id));
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.JOBOPENING_STATUS(id), data);
  }
}
